import { CloneDemandeConfiguration, CreationDemandeConfigurations, type CloneDemandeLaunch, } from "@/features/interface/demande/ajouter/CreationDemandeConfigurations"
import { MachineEtat } from "@/features/domaine/machine-etats/MachineEtats"
import { useAppContextStore } from "@/features/auth/context-app"
import api from '@/features/services/demande/DemandeAllService'

export function useAjouteDemande() {
  const appContext = useAppContextStore()

  async function showAjoute() {

    const engine = new MachineEtat(CreationDemandeConfigurations)
    const payload = await engine.launch({ titre: "Nouvelle demande", contextCourant: appContext.contextCourant })

    return await api.addDemande(payload)
  }

  async function showClone(options: CloneDemandeLaunch) {
    const engine = new MachineEtat(CloneDemandeConfiguration)
    const payload = await engine.launch({ titre: 'Dupliquer une demande', contextCourant: appContext.contextCourant, launchParams: options })
    // console.log('Fin duplications demande', payload.id)
    return await api.addDemande(payload)
  }

  return {
    showAjoute,
    showClone
  }
}



